const NEW_WINDOW_CONFIG = {
  height: 400,
  width: 550,
  location: 'no',
  toolbar: 'no',
  status: 'no',
  directories: 'no',
  menubar: 'no',
  scrollbars: 'yes',
  resizable: 'no',
  centerscreen: 'yes',
  chrome: 'yes',
  left: 237,
  top: 184,
};

export const NEW_WINDOW_FEATURES = Object.entries(NEW_WINDOW_CONFIG)
  .map(([key, value]) => `${key}=${value}`)
  .join(', ');

export const SHARE_URLS = {
  facebook: 'https://www.facebook.com/sharer/sharer.php?u=',
  linkedin: 'https://linkedin.com/shareArticle?url=',
  twitter: 'https://twitter.com/share?url=',
};
